const AccountListTableLangKey = [
	'column_id',
	'column_email',
	'column_login',
	'column_kt_group',
	'column_role',
	'column_is_buyer',
	'column_in_group',
	'column_is_team',
	'column_is_active',
	'column_is_fired',
	'column_date_registered',
	'column_date_deleted',
] as const

type IAccountListTableLangKey = typeof AccountListTableLangKey[number]

export type IAccountListTableLang = {
	account_list_table: Record<IAccountListTableLangKey, string>
}

const langEntries = AccountListTableLangKey.map(
	(key: IAccountListTableLangKey) => [key, `account_list_table.${key}`]
)

const langObj: Record<IAccountListTableLangKey, string> = Object.fromEntries(langEntries)

export const ACCOUNT_LIST_TABLE_LANG_KEY: IAccountListTableLang = {
	account_list_table: langObj
}
